export const environment = {
    production: false,
    enableDebug: true,
    
    envType: 'oncloud',
    apiUrl: window.location.origin + '/rest',
    keycloakUrl: window.location.origin + '/auth/',
    feBasePath: window.location.origin,
    realm: 'JoinYourBit',
    clientId: 'JoinYourBit',
    redirectUri: window.location.origin + '/',
    multiSign: true
};